import API from "./API";

let orgID = process.env.REACT_APP_ORGANIZATION_ID

export default class BannerDAO {
    static getBanners = async () => {
        return await API.request(`/v1/banner/organization/`+orgID, "GET");
    };

}